module.exports = __webpack_public_path__ + "img/forum_default.941b80a8.png";